import { useEffect, useState } from "react";
import api from "./api";
import { useNavigate } from "react-router-dom";
import { getUser, isAdmin } from "./auth";

export default function AdminUsers() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = getUser();

    if (!user || !isAdmin()) {
      navigate("/");
      return;
    }

    loadUsers();
  }, [navigate]);

  async function loadUsers() {
    try {
      setLoading(true);
      const res = await api.get("/api/admin/pending-users");
      setUsers(res.data || []);
    } catch (err) {
      console.error("Failed to load pending users", err);
      alert("You are not allowed to view this page.");
      navigate("/");
    } finally {
      setLoading(false);
    }
  }

  async function approve(id) {
    try {
      await api.post(`/api/admin/approve/${id}`);
      loadUsers();
    } catch (err) {
      console.error("Failed to approve user", err);
      alert(err?.response?.data?.error || "Could not approve user.");
    }
  }

  async function reject(id) {
    if (!window.confirm("Reject this user?")) return;

    try {
      await api.delete(`/api/admin/reject/${id}`);
      loadUsers();
    } catch (err) {
      console.error("Failed to reject user", err);
      alert(err?.response?.data?.error || "Could not reject user.");
    }
  }

  return (
    <div className="main-content">
      <h1>🔐 Admin Panel</h1>
      <p style={{ color: "#6b7280", marginTop: -8 }}>
        User Management — approve or reject new CMMS accounts.
      </p>

      <div className="card" style={{ marginTop: 18 }}>
        <h3 style={{ marginTop: 0 }}>Pending Users</h3>

        {loading ? (
          <p>Loading pending users...</p>
        ) : users.length === 0 ? (
          <p>No pending users ✅</p>
        ) : (
          <div className="table-wrapper">
            <div className="table-scroll">
              <table>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Email Verified</th>
                    <th>Role</th>
                    <th>Created</th>
                    <th style={{ width: 180 }}>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {users.map((u) => (
                    <tr key={u.id}>
                      <td>{u.email}</td>
                      <td>{u.email_verified ? "Yes" : "No"}</td>
                      <td>{u.role || "user"}</td>
                      <td>{u.created_at || "—"}</td>
                      <td>
                        <div style={{ display: "flex", gap: 8 }}>
                          <button
                            className="btn-sm btn-purple"
                            onClick={() => approve(u.id)}
                            disabled={!u.email_verified}
                            title={
                              !u.email_verified
                                ? "User must verify email first"
                                : "Approve user"
                            }
                          >
                            Approve
                          </button>

                          <button
                            className="btn-sm"
                            onClick={() => reject(u.id)}
                            style={{
                              background: "#ef4444",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Reject
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}